import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { COLORS } from '../../Constants/styles';

interface BannerData {
  title: string;
  description: string;
  image: string;
}

const BannerSection = ({ data }: { data: BannerData }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        py: { xs: 6, md: 8 },
        backgroundImage: `url(${data.image})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: { xs: '44vh', md: '60vh' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        overflow: 'hidden',
      }}
    >
      {/* Dark overlay for contrast */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.45)',
          zIndex: 1,
        }}
      />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2, color: COLORS.white }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
            {data.title}
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <Typography variant="h1" component="h2" sx={{ mt: 3, mb: 2 }}>
            {data.description}
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default BannerSection;
